
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-privacy-policy",
      function () {
        return require("private-next-pages/our-privacy-policy/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-privacy-policy"])
      });
    }
  